const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(-3490.355 -251.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(3491.355 252.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Stroke_242",
    d: "M20 10A10 10 0 1 1 10 0a10 10 0 0 1 10 10z",
    "data-name": "Stroke 242",
    style: {
      fill: "none",
      stroke: "#09c3ad",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Stroke_904_Stroke_905_Stroke_906",
    "data-name": "Stroke 904 + Stroke 905 + Stroke 906",
    transform: "translate(6.637 6.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Stroke_906",
    d: "M7.228 0L2.077 7.82 0 5.557",
    "data-name": "Stroke 906",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "#09c3ad",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.b873b032a0c13a7c97208bb449de3346.svg";
export { ForwardRef as ReactComponent };